import $apiJSON from 'http/apiJSON'

export async function getUserData() {
  // GET /api/userdata/
  return $apiJSON.get('/userdata/')
}

export async function patchUserData(payload) {
  // PATCH /api/userdata/ with JSON body
  return $apiJSON.patch('/userdata/', payload)
}

export async function patchUserDataForm(formData) {
  // PATCH /api/userdata/ with multipart/form-data (FormData instance)
  return $apiJSON.patch('/userdata/', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
}

export async function getPurchases(page = 1) {
  // GET /api/purchases/?page=
  return $apiJSON.get('/purchases/', { params: { page } })
}

export async function getUserAddresses() {
  return $apiJSON.get('account/addresses/')
}

export async function createUserAddress(data) {
  return $apiJSON.post('account/addresses/', data)
}

export async function updateUserAddress(id, data) {
  return $apiJSON.patch(`account/addresses/${id}/`, data)
}

export async function deleteUserAddress(id) {
  return $apiJSON.delete(`account/addresses/${id}/`)
}

export async function getUserPaymentMethods() {
  return $apiJSON.get('account/payment-methods/')
}

export async function createUserPaymentMethod(data) {
  return $apiJSON.post('account/payment-methods/', data)
}

export async function updateUserPaymentMethod(id, data) {
  return $apiJSON.patch(`account/payment-methods/${id}/`, data)
}

export async function deleteUserPaymentMethod(id) {
  return $apiJSON.delete(`account/payment-methods/${id}/`)
}

export async function getTitles() {
  return $apiJSON.get('account/titles/')
}

export async function getUserDashboard() {
  return $apiJSON.get('account/dashboard/')
}

export default { 
  getUserData, 
  patchUserData, 
  patchUserDataForm, 
  getPurchases,
  getUserAddresses,
  createUserAddress,
  updateUserAddress,
  deleteUserAddress,
  getUserPaymentMethods,
  createUserPaymentMethod,
  updateUserPaymentMethod,
  deleteUserPaymentMethod,
  getTitles,
  getUserDashboard
}
